import { render, staticRenderFns } from "./ForwardMessageDetail.vue?vue&type=template&id=19af97ba&scoped=true"
import script from "./ForwardMessageDetail.vue?vue&type=script&lang=js"
export * from "./ForwardMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./ForwardMessageDetail.vue?vue&type=style&index=0&id=19af97ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af97ba",
  null
  
)

export default component.exports